import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import SearchBox from "../../common/components/SearchBox";
import { Typography, Toolbar, Button } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import AssessmentIcon from "@mui/icons-material/Assessment";
import RateReviewIcon from "@mui/icons-material/RateReview";
import {
  getRecruitmentReports,
  deleteRecruitmentReport,
} from "../../../store/recruitment/actions";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import TableSkeleton from "../../common/components/TableSkeleton";

import BackdropLoader from "../../common/components/BackdropLoader";
import moment from "moment";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import RecruitmentReportLeftSide from "../components/RecruitmentReportLeftSide";
import RecruitmentReportModal from "../components/RecruitmentReportModal";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const RecruitmentReports = (props) => {
  const { recruitmentReports, getRecruitmentReports, section, loading } = props;

  const dispatch = useDispatch();
  const { hasPermissions } = useRequiredAuth();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 15
  );
  const [totalRequests, setTotalRequests] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);

  const [showAddRecruitmentReportForm, setShowRecruitmentReportForm] =
    useState(false);

  useEffect(() => {
    dispatch({
      type: "SET_REPORTS",
      data: [],
    });
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
      section,
    };

    getRecruitmentReports(query, setTotalRequests, setIsLoading);
  }, [section]);

  const onSearch = () => {
    if (!searchTerm) return false;
    const query = {
      searchTerm: searchTerm,
      page: 1,
      size: itemPerPage,
      section,
    };
    getRecruitmentReports(query, setTotalRequests, setIsLoading);
  };

  const refreshReports = () => {
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
      section,
    };
    getRecruitmentReports(query, setTotalRequests, setIsLoading1);
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
      section,
    };
    getRecruitmentReports(query, setTotalRequests, setIsLoading1);
  };

  return (
    <>
      <div className="row mx-0">
        <div className="col-2">
          <RecruitmentReportLeftSide />
        </div>
        <div className="col-10 mt-2">
          <div className="pr-3">
            <AppBar
              position="static"
              elevation={0}
              style={{ overflow: "hidden" }}
              className="app-bar w-100"
            >
              <Toolbar className="row">
                <div className="col-lg-5">
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    className="text-uppercase"
                  >
                    <span style={{ color: "rgb(7, 142, 206)" }}>
                      {searchTerm ? "Filtered Reports" : "Reports"}(
                      {totalRequests})
                    </span>
                    {hasPermissions(["IS_HR"]) && section === "IN_PROGRESS" && (
                      <Button
                        onClick={() => {
                          dispatch({
                            type: "SET_REPORT",
                            data: null,
                          });
                          setShowRecruitmentReportForm(true);
                        }}
                        variant="contained"
                        size="small"
                        disableElevation
                        className="mr-2 "
                        style={{
                          borderRadius: "8px",
                          height: "38px",
                          border: `1px solid rgb(7, 142, 206)`,
                          color: "#fff",
                          alignItems: "center",
                          fontSize: ".75rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textTransform: "initial",
                          backgroundColor: "rgb(7, 142, 206)",
                          marginLeft: "5px",
                          "&:hover": {
                            backgroundColor: "#f0f2f5",
                          },
                        }}
                      >
                        <span className="material-icons">add</span>Report
                      </Button>
                    )}
                  </Typography>
                </div>

                <div className="col-lg-7">
                  <div className="d-flex justify-content-right  align-items-right">
                    <SearchBox
                      onSearch={(search) => {
                        setSearchTerm(search);

                        if (!search) {
                          const currentPage = 1;
                          setCurrentPage(currentPage);
                          const query = {
                            searchTerm: "",
                            page: currentPage,
                            size: itemPerPage,
                            section,
                          };
                          getRecruitmentReports(
                            query,
                            setTotalRequests,
                            setIsLoading1
                          );
                        }
                      }}
                      placeholder="Search…"
                    />
                    <Button
                      disabled={!searchTerm}
                      onClick={() => onSearch()}
                      variant="contained"
                      size="small"
                      disableElevation
                      className="mr-2 "
                      style={{
                        borderRadius: "8px",
                        height: "38px",
                        border: `1px solid rgb(7, 142, 206)`,
                        color: "#fff",
                        alignItems: "center",
                        fontSize: ".75rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textTransform: "initial",
                        backgroundColor: "rgb(7, 142, 206)",
                        marginLeft: "5px",
                        "&:hover": {
                          backgroundColor: "#f0f2f5",
                        },
                      }}
                    >
                      <span className="material-icons">search</span>GO
                    </Button>
                  </div>
                </div>
              </Toolbar>
            </AppBar>
            {showAddRecruitmentReportForm && (
              <RecruitmentReportModal
                showAddRecruitmentReportForm={showAddRecruitmentReportForm}
                setShowRecruitmentReportForm={setShowRecruitmentReportForm}
                section={section}
                onRefreshReports={refreshReports}
              />
            )}

            <table className="table table-striped table-hover table-sm  fixTableHead">
              <thead>
                <tr style={{ backgroundColor: "#f0f2f5" }}>
                  <th scope="col">#</th>

                  <th scope="col" className="text-left py-2">
                    Title
                  </th>
                  <th scope="col" className="text-left">
                    Institution
                  </th>

                  <th scope="col" className="text-left">
                    Reported Positions
                  </th>

                  <th scope="col" className="text-left">
                    InitiatedOn
                  </th>
                  <th scope="col" className="text-left"></th>

                  <th scope="col" className="text-right"></th>
                </tr>
              </thead>
              {isLoading ? (
                <TableSkeleton cols={6} />
              ) : (
                <tbody>
                  <BackdropLoader isLoading={isLoading1} />
                  {recruitmentReports.map((report, index) => (
                    <RecruitmentReportCard
                      dispatch={dispatch}
                      hasPermissions={hasPermissions}
                      report={report}
                      index={index}
                      key={index}
                      loading={loading}
                      setShowRecruitmentReportForm={
                        setShowRecruitmentReportForm
                      }
                      section={section}
                    />
                  ))}
                </tbody>
              )}
            </table>
            <NoRecordMessage
              isEmpty={!recruitmentReports.length && !isLoading}
              title={"No record found"}
            />
            {!isLoading && (
              <div
                className="d-flex justify-content-center  align-items-center"
                style={{ overflow: "hidden" }}
              >
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    // marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRequests / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-info btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                {!!recruitmentReports.length && (
                  <select
                    className="custom-select custom-select-sm ml-2"
                    style={{ width: "100px" }}
                    value={itemPerPage}
                    onChange={(event) => {
                      const itemPerPage = +event.target.value;
                      window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                      setItemPerPage(itemPerPage);
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                        section,
                      };
                      getRecruitmentReports(
                        query,
                        setTotalRequests,
                        setIsLoading
                      );
                    }}
                  >
                    {[10, 15, 20, 50, 100].map((item, index) => (
                      <option key={index}>{item}</option>
                    ))}
                  </select>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user, loading, recruitmentReports }) => {
  return { user, loading, recruitmentReports };
};
export default connect(mapStateToProps, {
  getRecruitmentReports,
})(RecruitmentReports);

const RecruitmentReportCard = (props) => {
  const {
    loading,
    report,
    index,
    dispatch,
    setShowRecruitmentReportForm,
    hasPermissions,
    section,
  } = props;
  const openDialog = () => {
    dispatch({
      type: "SET_REPORT",
      data: report,
    });
    setShowRecruitmentReportForm(true);
  };
  const renderButton = () => {
    if(section === "ASSIGNED" && hasPermissions(["IS_NPSC_SUPERVISOR"])) {
      return (
        <button
          type="button"
          className="btn btn-info m-2"
          onClick={() => openDialog()}
        >
          <OpenInNewIcon /> View
        </button>
      );
    }
    if (
      [10].includes(+report?.statusId) &&
      hasPermissions([
        "IS_NPSC_APPROVER"
      ])
    ) {
      return (
        <button
          type="button"
          className="btn btn-success m-2"
          onClick={() => openDialog()}
        >
          <CheckCircleIcon /> Approve
        </button>
      );
    }

    if (
      [1].includes(+report?.statusId) &&
      hasPermissions(["IS_CBM"])
    ) {
      return (
        <button
          type="button"
          className="btn btn-primary m-2"
          onClick={() => openDialog()}
        >
          <RateReviewIcon /> Review
        </button>
      );
    }

     if (
      [2].includes(+report?.statusId) &&
      hasPermissions(["IS_NPSC"])
      && !hasPermissions(["IS_NPSC_SUPERVISOR",'IS_NPSC_APPROVER']) 
      && section!='ASSIGNED'
    ) {
      return (
        <button
          type="button"
          className="btn btn-primary m-2"
          onClick={() => openDialog()}
        >
          <RateReviewIcon /> Review
        </button>
      );
    }

    if (
      [2].includes(+report?.statusId) &&
     hasPermissions(["IS_NPSC_SUPERVISOR"]) 
      && section!='ASSIGNED'
    ) {
      return (
        <button
          type="button"
          className="btn btn-success m-2"
          onClick={() => openDialog()}
        >
          <PersonAddIcon /> Assign
        </button>
      );
    }

    if (
      [3].includes(+report?.statusId) &&
     hasPermissions(["IS_NPSC_SUPERVISOR"]) 
      && section!='ASSIGNED'
    ) {
      return (
        <button
          type="button"
          className="btn btn-warning m-2"
          onClick={() => openDialog()}
        >
          <CheckCircleIcon /> Verify
        </button>
      );
    }

    if ([7].includes(+report?.statusId) && hasPermissions(["IS_HR"])) {
      return (
        <button
          type="button"
          className="btn btn-primary m-2"
          onClick={() => openDialog()}
        >
          <AssessmentIcon />
          Modify Draft
        </button>
      );
    }

    return (
      <button
        type="button"
        disabled={loading}
        className="btn btn-secondary m-2"
        onClick={() => openDialog()}
      >
        <OpenInNewIcon /> Open
      </button>
    );
  };
  return (
    <>
      <tr>
        <th scope="row" style={{ backgroundColor: "#f0f2f5" }}>
          {index + 1}
        </th>
        <td className="text-left"> {report.title}</td>
        <td className="text-left"> {report.entityName}</td>
        <td className="text-left"> {report.numberOfPosts}</td>
        <td className="text-left">
          {" "}
          {moment(report.createdOn).format("YYYY-MM-DD")}
        </td>
        <td className="text-left">
         {section === "ASSIGNED" && (
          <>
          {report.totalAssigned > 0 && (
              <>
                <div className="text-success ml-2 d-flex justify-content-end">
                  <span className="material-icons">person_add</span>
                 <span className="ml-2 font-weight-bold "> {report.totalAssigned} assigned</span>
                </div>
              </>
            )}
          </>
          )}
          {section !== "ASSIGNED" && (
            <>
            <span
            className={`font-weight-bold text-uppercase text-${
              [5, 6].includes(+report.statusId)
                ? "danger"
                : [1, 2, 3].includes(+report.statusId)
                ? "primary"
                : [7,10].includes(+report.statusId)
                ? "warning"
                : "success"
            }`}
          >
            {report.statusName}
          </span>
            </>
          )}
        </td>

        <td className="text-right">{renderButton()}</td>
      </tr>
    </>
  );
};
